export default __webpack_public_path__ + "static/media/book-nav-icon6-hover.137a5f60.svg";